import React, { createContext, useContext } from 'react';
import { Menu } from 'antd';
import Btn, { btnTypes } from '../../../../../components/btn';
import Column from '../../../shared/ui/Column';
import ControlledDropdown from '../../../shared/ui/ControlledDropdown';
import FieldArraySelector from '../../../controllers/FieldArraySelector';
import CreateDeskNameOption from './CreateDeskNameOption';
import AddDeskOption from './AddDeskOption';
import {
  getValueFromFormState,
  useFormControllerState,
} from '../../../../../helpers/formManager';
import { fieldNames } from '../../../shared/configs/acceptanceForm';
import BaseError from '../../../../../components/BaseError';

const DesksValidationContext = createContext();

const DesksCol = () => {
  return (
    <Column title="Столы" action={<AddActions />}>
      <DesksValidationProvider>
        <Content />
      </DesksValidationProvider>
    </Column>
  );
};

export default DesksCol;

function Content() {
  const errorMessage = useContext(DesksValidationContext);

  return errorMessage ? (
    <BaseError description={errorMessage} />
  ) : (
    <FieldArraySelector type={FieldArraySelector.types.desk} />
  );
}

function DesksValidationProvider({ children }) {
  const { errors } = useFormControllerState({ name: fieldNames.main.desks });

  const { root } = getValueFromFormState(errors, fieldNames.main.desks) || {};

  return (
    <DesksValidationContext.Provider value={root?.message}>
      {children}
    </DesksValidationContext.Provider>
  );
}

function AddActions() {
  return (
    <ControlledDropdown renderButton={renderButton} renderOverlay={Overlay} />
  );
}

function renderButton() {
  return <Btn type={btnTypes.primaryInvert}>Добавить</Btn>;
}

function Overlay({ onClose, ...props }) {
  return (
    <Menu {...props}>
      <CreateDeskNameOption onClose={onClose} />
      <AddDeskOption onClose={onClose} />
    </Menu>
  );
}
